export default {
    fileUpload: require('./file-upload/upload-button-lead-contact.svg'),
    removeFile: require('./remove-file/remove-file.svg'),
}
